// extracted by mini-css-extract-plugin
export default {"search":"TableTools_search__7nTBu","wrapper":"TableTools_wrapper__Z4XXX"};